import styled from 'styled-components';
import { colors } from 'bench-style-constants';

const TransactionSidebarDataEntryText = styled.span`
  ${({ isCurrentLedger }) => (!isCurrentLedger ? `color: ${colors.stone};` : `font-weight: 600;`)};
`;

export default TransactionSidebarDataEntryText;
